import { useEffect, useId, useRef, useState } from 'react';
import { Info } from 'lucide-react';
import './LoginInfoTip.css';

/**
 * Compact info control for login headers — long copy opens on click (touch-friendly).
 */
export default function LoginInfoTip({ text, label = 'About this login', className = '' }) {
  const [open, setOpen] = useState(false);
  const tipId = useId();
  const rootRef = useRef(null);
  const body = String(text || '').trim();

  useEffect(() => {
    if (!open || !body) return undefined;
    const onPointerDown = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open, body]);

  if (!body) return null;

  return (
    <span
      ref={rootRef}
      className={`login-info-tip${open ? ' is-open' : ''}${className ? ` ${className}` : ''}`}
    >
      <button
        type="button"
        className="login-info-tip__btn"
        aria-label={label}
        aria-expanded={open}
        aria-controls={tipId}
        onClick={() => setOpen((prev) => !prev)}
      >
        <Info size={18} strokeWidth={2.25} aria-hidden="true" />
      </button>
      {open ? (
        <span id={tipId} className="login-info-tip__panel" role="note">
          {body}
        </span>
      ) : null}
    </span>
  );
}
